import React, { Component } from 'react';
import parse from 'html-react-parser';
import { Analytics } from '../../../utils/common/analytics';
import PropTypes from 'prop-types';

class CartValidationErrorMessage extends Component {
	logError() {
		const errorMessage = this.analytics.getPageItem('errorMessage') || [];
		errorMessage.push({
			event: 'eventWebAppMsg',
			data: {
				eventType: 'page error',
				errorMessage: 'Unable to Verify License',
			},
		});
		this.analytics.addPageInfo({
			errorMessage,
		});
	}

	componentDidMount() {
		this.analytics = Analytics.getInstance();
		this.logError();
	}

	componentDidUpdate(prevProps) {
		if (this.props.errorTitle !== prevProps.errorTitle || this.props.errorMessage !== prevProps.errorMessage) {
			this.logError();
		}
	}

	render() {
		return (
			<div className="padding-leader-2 padding-trailer-2">
				<div className="cart-alert globalError topborder">
					<div className="cart-alert-icon"></div>
					<div className="cart-alert-text">
						<span className="esri-font-demi"> {this.props.errorTitle} </span> <br />
						<div className="richtext-container">{this.props.errorMessage && parse(this.props.errorMessage)}</div>
					</div>
				</div>
			</div>
		);
	}
}

CartValidationErrorMessage.propTypes = {
	errorTitle: PropTypes.string.isRequired,
	errorMessage: PropTypes.string.isRequired,
};

export default CartValidationErrorMessage;
